/**
 * @fileoverview GET handler for the "/recent_interactions" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { recentInteractions } from "./constants";
import type { RecentInteractionsResult } from "./types";

export const getRecentInteractions = reactQueryFetcherAdapter(
  recentInteractions,
  (signal: AbortSignal, appGroupId: string): Promise<RecentInteractionsResult> => {
    return fetch("/recent_interactions", "GET", { app_group_id: appGroupId }, { signal });
  }
);
